import React, { useState } from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import {
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  ButtonGroup,
  Typography,
  Box
} from '@mui/material';

const FilterBar = ({ filters, onFilterChange, peerData }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  // Extract unique departments from peer data
  const departments = peerData && Array.isArray(peerData)
    ? ['all', ...new Set(peerData.map(d => d.department).filter(Boolean))]
    : ['all'];

  const riskLevels = [
    { value: 'all', label: 'All Risk Levels' },
    { value: 'HIGH_RISK_CREEP', label: 'High Risk Creep' },
    { value: 'MODERATE_CREEP', label: 'Moderate Creep' },
    { value: 'LOW_RISK', label: 'Low Risk' },
    { value: 'APPROPRIATE_ACCESS', label: 'Appropriate Access' }
  ];

  const minRiskScores = [
    { value: '', label: 'Any Score' },
    { value: 8, label: '8+ (Critical)' },
    { value: 6, label: '6+ (High)' },
    { value: 4, label: '4+ (Moderate)' },
    { value: 2, label: '2+ (Low)' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
  };

  const applyFilters = () => {
    const filterParams = {};

    if (localFilters.department && localFilters.department !== 'all') {
      filterParams.department = localFilters.department;
    }

    if (localFilters.riskLevel && localFilters.riskLevel !== 'all') {
      filterParams.classification = localFilters.riskLevel;
    }

    if (localFilters.minRiskScore) {
      filterParams.minRiskScore = localFilters.minRiskScore;
    }

    filterParams.limit = localFilters.limit || 50;

    onFilterChange(filterParams);
  };

  const resetFilters = () => {
    const defaultFilters = {
      department: 'all',
      riskLevel: 'all',
      classification: null,
      minRiskScore: null,
      limit: 50,
      offset: 0
    };
    setLocalFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };

  const exportReport = () => {
    alert('Export functionality coming soon!');
    // TODO: Implement CSV/PDF export
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Grid2 container spacing={2} alignItems="flex-end">
          {/* Department Filter */}
          <Grid2 xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Department</InputLabel>
              <Select
                label="Department"
                value={localFilters.department || 'all'}
                onChange={(e) => handleFilterChange('department', e.target.value)}
              >
                {departments.map(dept => (
                  <MenuItem key={dept} value={dept}>
                    {dept === 'all' ? 'All Departments' : dept}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>

          {/* Risk Level Filter */}
          <Grid2 xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Risk Classification</InputLabel>
              <Select
                label="Risk Classification"
                value={localFilters.riskLevel || 'all'}
                onChange={(e) => handleFilterChange('riskLevel', e.target.value)}
              >
                {riskLevels.map(level => (
                  <MenuItem key={level.value} value={level.value}>
                    {level.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>

          {/* Min Risk Score Filter */}
          <Grid2 xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Min Score</InputLabel>
              <Select
                label="Min Score"
                value={localFilters.minRiskScore || ''}
                onChange={(e) => handleFilterChange('minRiskScore', e.target.value ? parseInt(e.target.value) : null)}
              >
                {minRiskScores.map(score => (
                  <MenuItem key={score.value || 'any'} value={score.value}>
                    {score.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>

          {/* Results Per Page */}
          <Grid2 xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Results</InputLabel>
              <Select
                label="Results"
                value={localFilters.limit || 50}
                onChange={(e) => handleFilterChange('limit', parseInt(e.target.value))}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </Grid2>

          {/* Action Buttons */}
          <Grid2 xs={12} md={2}>
            <ButtonGroup size="small" fullWidth>
              <Button
                variant="contained"
                onClick={applyFilters}
              >
                Apply
              </Button>
              <Button
                variant="outlined"
                onClick={resetFilters}
                title="Reset Filters"
              >
                Reset
              </Button>
            </ButtonGroup>
          </Grid2>
        </Grid2>

        {/* Quick Actions Row */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Use filters to narrow down results and identify specific risk areas
          </Typography>
          <Button
            variant="outlined"
            color="success"
            size="small"
            onClick={exportReport}
          >
            Export Report
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FilterBar;
